import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const ADODOTNET = () => {
  return (
    <StartInterviewLayout type="ado-dotnet"/>
  )
}

export default ADODOTNET;